import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Ban } from 'tabler-icons-react';

import { StyledTable } from 'components/shared';
import { ClientUserDTO } from 'interfaces';
import { TableCell, TableRow } from 'storybook';

import styles from './ClientDetailsBanHistory.module.css';

export const ClientDetailsBanHistory = (client: ClientUserDTO) => {
   const { t } = useTranslation();

   const columnHeaders = useMemo(
      () => [
         { label: t('comments.table.date'), field: 'date' },
         { label: t('clientDetailsBanHistory.actions'), field: 'actions' },
         { label: t('comments.table.content'), field: 'content' },
      ],
      [t],
   );

   return (
      <StyledTable className={styles.tableContainer} columnHeaders={columnHeaders}>
         {client.historyOfSuspensions.length ? (
            client.historyOfSuspensions.map((suspension, index) => {
               const formattedDate = new Date(suspension.createDate).toLocaleDateString();
               return (
                  <TableRow key={index}>
                     <TableCell>{formattedDate}</TableCell>
                     <TableCell>
                        {suspension.suspension.blocked ? (
                           <div className={styles.blockedRow}>
                              <Ban color="var(--primary-red)" />
                              <span style={{ color: 'var(--primary-red)' }}>
                                 {t('clientDetailsBanHistory.blocked')}
                              </span>
                           </div>
                        ) : (
                           <div className={styles.blockedRow}>
                              <Ban />
                              {t('clientDetailsBanHistory.unblocked')}
                           </div>
                        )}
                     </TableCell>
                     <TableCell>{suspension.suspension.reason || '-'}</TableCell>
                  </TableRow>
               );
            })
         ) : (
            <tr>
               <td align="center" colSpan={3}>
                  <div className={styles.noResultsContainer}>
                     <Ban size={42} />
                     <p>{t('clientDetailsBanHistory.noHistory')}</p>
                  </div>
               </td>
            </tr>
         )}
      </StyledTable>
   );
};
